import ExpandMore from '@mui/icons-material/ExpandMore';
import { FormControl, InputLabel, Select as MuiSelect, Typography, MenuItem } from '@mui/material';
import { forwardRef } from 'react';

import ThemeProvider from '@toolbox/style/theme/common/ThemeProvider/ThemeProvider';
import { neutrals } from '@toolbox/style/theme/common/ThemeProvider/colors';
import { fontSizes } from '@toolbox/style/theme/foundations/typography';

import type { FormControlProps, SelectProps, SelectChangeEvent } from '@mui/material';

export interface CustomSelectProps extends SelectProps {
  /** Props for Material UI FormControl see https://mui.com/material-ui/api/form-control/#props. */
  formControlProps?: FormControlProps;
  /** Informational text below the input. Will be hidden if it is not defined. */
  helperText?: string;
  options: { value: string; label: string }[];
  onChange: (event: SelectChangeEvent<unknown>) => void;
  label: string;
  keepErrorSpace?: boolean;
}

// eslint-disable-next-line react/display-name
export const Select = forwardRef<unknown, CustomSelectProps>(
  ({ options, formControlProps, helperText, keepErrorSpace = true, ...restProps }, ref) => (
    <ThemeProvider>
      <FormControl fullWidth>
        {restProps.label && (
          <InputLabel
            sx={() => (restProps.disabled ? { color: neutrals.lighter } : {})}
            id={restProps.labelId || `${restProps.name}-label`}
          >
            {restProps.label}
          </InputLabel>
        )}
        <MuiSelect
          ref={ref}
          labelId={`${restProps.id}-label`}
          IconComponent={ExpandMore}
          {...restProps}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </MuiSelect>
        {(helperText || keepErrorSpace) && (
          <Typography
            sx={({ palette }) => ({
              minHeight: '20px',
              marginLeft: 2,
              marginTop: 0.5,
              color: restProps.error ? palette.error.main : palette.primary.main,
              fontSize: fontSizes.f1,
            })}
          >
            {helperText}
          </Typography>
        )}
      </FormControl>
    </ThemeProvider>
  ),
);
